import { TButtonSize } from '@cian/ui-kit/button/types';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './PhoneButtonSwitcher.css';
import { PhoneButton } from '../PhoneButton';
import { Phone } from '../phone';

export interface IPhoneButtonSwitcherProps {
  phone?: string | null;
  ignorePhoneReplace?: boolean;
  buttonSize?: TButtonSize;
  fullWidth?: boolean;
  trackShowPhoneClick?(): void;
}

export interface IPhoneButtonSwitcherState {
  isPhoneClicked: boolean;
}

export class PhoneButtonSwitcher extends React.Component<IPhoneButtonSwitcherProps, IPhoneButtonSwitcherState> {
  public state = {
    isPhoneClicked: false,
  };

  public render() {
    const { phone, ignorePhoneReplace, buttonSize, fullWidth } = this.props;
    const { isPhoneClicked } = this.state;
    if (!phone) {
      return null;
    }

    const { className: phoneTextStyles } = mergeStyles(styles['phone'], buttonSize === 'M' && styles['phone--m']);

    return (
      <div className={styles['container']}>
        <div className={styles['phone_button_container']}>
          {isPhoneClicked && !ignorePhoneReplace ? (
            <Phone phone={phone} style={phoneTextStyles} />
          ) : (
            <PhoneButton
              onClick={() => setTimeout(this.handlePhoneCollapseButtonChange, 0)}
              buttonSize={buttonSize}
              fullWidth={fullWidth}
            />
          )}
        </div>
      </div>
    );
  }

  private handlePhoneCollapseButtonChange = () => {
    const { trackShowPhoneClick } = this.props;

    this.setState({
      isPhoneClicked: true,
    });

    if (trackShowPhoneClick) {
      trackShowPhoneClick();
    }
  };
}
